module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ../~/safe-buffer/browser.js
// module id = 132
// module chunks = 0